import { 
/* tree-shaking no-side-effects-when-called */ createContext, } from 'react';
const SchemaAnalyzerContext = createContext(null);
export default SchemaAnalyzerContext;
//# sourceMappingURL=SchemaAnalyzerContext.js.map